import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { AppConfig } from '../Shared/configs/app.config';
import { CustomerDropOffLog } from '../Models/CustomerDropOffLogModel';
import { CallDealerLogEntryRequestModel } from '../Models/call-dealer-log-entry-requestModel';

@Injectable({
  providedIn: 'root'
})
export class CheckInDataService {
  DemandWiseDocumentCountList: any[] = [];
  public cdkRepairDetails = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly dataProvider: DataService) { }

  public GetCheckInModuleData() {
    return this.dataProvider.Get<any>(AppConfig.GET_CHECK_IN_MODULE_DATA_URL);
  }

  public GetCheckInCustomerCount(_params?: any) {
    return this.dataProvider.Get(AppConfig.GET_CHECK_IN_CUSTOMER_COUNT_URL);
  }

  public GetNotCheckInCustomerCount(_params?: any) {
    return this.dataProvider.Get(AppConfig.GET_NOT_CHECK_IN_CUSTOMER_COUNT_URL);
  }

  public DecryptTinyUrl(checkInModel: any) {
    return this.dataProvider.CheckInValidate<any>(AppConfig.DECRYPT_TINY_URL, checkInModel);
  }

  public GetStatusTrackerTinyUrl() {
    return this.dataProvider.Get(AppConfig.GET_STATUS_TRACKER_TINY_URL);
  }

  public GetCdkRepairData() {
    return this.dataProvider.Get<any>(AppConfig.GET_CDK_REPAIR_MODULE_DATA_URL);
  }
  public GetBrandDetails(): Observable<any> {
    return this.dataProvider.Get<Observable<any>>(AppConfig.GET_BRANDS);
  }
  public GetDocumentSignUrl(): Observable<any> {
    return this.dataProvider.Get<Observable<any>>(AppConfig.GET_DOCUMENT_SIGN_URL);
  }
  public StoreRouteTraversalLog(routeModel: CustomerDropOffLog) {
    return this.dataProvider.Post<any>(AppConfig.STORE_TRAVERSAL_LOG_URL, routeModel).toPromise();
  }
  callDealerLogEntry(request: CallDealerLogEntryRequestModel) {
    return this.dataProvider.Post(AppConfig.CALL_DEALER_LOG_ENTRY_URL, request);
  }
  GetDocumentCount(): Promise<any> {
    return this.dataProvider.Get<GenericResponse<any>>(AppConfig.GET_DEMANDWISE_DOCUMENT_COUNT).toPromise();
  }
  GetDemandWiseDocuments(demandId: number): Promise<any> {
    return this.dataProvider.Get<any>(AppConfig.GET_DEMAND_DOCUMENT, demandId).toPromise();
  }
  SendWarrantyDocument(model: any) : Promise<any>{
    return this.dataProvider.GetAllwithHeaders(AppConfig.SENT_WARRANTY_DOC_URL, model).toPromise();
  }
}
